import { Component, computed, DestroyRef, OnInit, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { assets } from '../../core/constants/assets.const';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CountryService } from '../../services/countryCurrency.service';
import { EncryptionService } from '../../services/encryption.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { countryResponse } from '../../models/countryCurrency.model';
import { AuctionDateEntry, enquiry } from '../../models/enquiries';
import { CommonModule } from '@angular/common';
import { EnquiryService } from '../../services/enquiries.service';
import { withLoader } from '../../core/helpers/loader.operator';
import { NgxUiLoaderService, NgxUiLoaderModule } from 'ngx-ui-loader';
import { TranslatePipe } from '../../core/pipes/translate.pipe';
import { I18nService } from '../../services/i18n.service';
import {
  addRoundedDecimals,
  MONEY_DECIMALS,
  truncateToDecimals,
} from '../../core/helpers/decimal.helper';

@Component({
  selector: 'logibids-ride-completed-modal',
  imports: [ButtonModule, TranslatePipe, CommonModule, NgxUiLoaderModule],
  templateUrl: './ride-completed-modal.component.html',
  styleUrl: './ride-completed-modal.component.scss',
})
export class RideCompletedModalComponent implements OnInit {
  assetsConst = assets;
  protected enquiry = signal<enquiry | null>(null);
  protected readonly totalWaiting = computed(() => {
    const cost = this.enquiry()?.cost;
    if (!cost) {
      return 0;
    }

    return truncateToDecimals(
      (cost.waiting_charge || 0) + (cost.waiting_sp_tax || 0),
      MONEY_DECIMALS
    );
  });
  protected readonly charge = computed(() => this.enquiry()?.fareTrack ?? 0);
  protected readonly displayedTotalAmount = computed(() => {
    const current = this.enquiry();
    if (!current) {
      return 0;
    }

    if (
      current.module_id === 'TRANSPORT' &&
      current.schedule_type === 'IMMEDIATE'
    ) {
      return addRoundedDecimals(
        [this.totalWaiting(), this.charge()],
        MONEY_DECIMALS
      );
    }

    return truncateToDecimals(Number(current.totalAmount), MONEY_DECIMALS);
  });
  /** Pre-split schedule dates per location (delegated to enquiry.formattedDates). */
  protected readonly arrayDates = computed<ReadonlyArray<AuctionDateEntry>>(
    () => this.enquiry()?.formattedDates ?? []
  );
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  user: any;
  currencyRate: string;
  constructor(
    public config: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef,
    private destroyRef: DestroyRef,
    private router: Router,
    private _encryption: EncryptionService,
    private _CountryService: CountryService,
    private translateService: I18nService,
    private _EnquiryService: EnquiryService,
    private ngxLoader: NgxUiLoaderService
  ) {
    this.user = this._encryption.decryptLocalStorage('profile');
  }

  ngOnInit(): void {
    if (this.config.data && this.user) {
      this.getCurrencyRate(this.config.data);
    }
  }

  getCurrencyRate(data): void {
    this._CountryService
      .getCountryCurrencyRate(this.user.country_code)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: countryResponse) => {
        this.currencyRate = res.curr_rate_kd;
        if (this.currencyRate && data) {
          this.getEnquiry();
        }
      });
  }

  getEnquiry() {
    this._EnquiryService
      .getEnqueryById(this.config.data.id)
      .pipe(
        withLoader(this.ngxLoader, 'uniqueLoader1'),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: (res: enquiry) => {
          this.enquiry.set(
            new enquiry(
              {
                ...res,
                currencyRate: this.currencyRate,
                userCurrency: this.user.currency_code,
              },
              this.translateService
            )
          );
        },
      });
  }

  btn_route(): void {
    this.dialogRef.close();
    if (this.user.type !== 'DRIVER') {
      this.router.navigateByUrl(`/sp-bids/sp-auctions`);
    } else {
      this.router.navigateByUrl(`/driver-home`);
    }
  }
}
